import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Service, { inject } from '@ember/service';
import { getOwner } from '@ember/application';
import '@ember/object';
import { sendSocketPageView } from '../lib/utility/currency.js';
import 'moment-timezone';
import { modelVar } from '../lib/utility/models.js';

var _class, _descriptor;
let SocketTrackerService = (_class = class SocketTrackerService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
  }
  trackPage(model, transition) {
    const applicationController = this._getApplicationController();
    document.documentElement.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    const {
      to: toRouteInfo
    } = transition;
    const params = toRouteInfo.params;
    const isView = toRouteInfo.name;
    const openCards = applicationController.openCards;
    let isPresent = openCards.find(i => i.item.id === model.id);
    let obj = null;
    if (!applicationController.isSmallDevice) {
      const orgName = this.session.me?.organization?.name || '';
      let pageTitle = `${orgName} | Beebeeboard`;
      if (['list', 'calendar.index', 'calendar'].includes(toRouteInfo.name)) {
        const modelName = params.model_name || (toRouteInfo.name.includes('calendar') ? 'calendar' : null);
        isPresent = openCards.find(i => i.url === modelName);
        sendSocketPageView(applicationController.socket, modelName, false, null, true);
        let nameToShow = this.session.me?.organization?.[modelName + '_name'] || modelName;
        let translateModelName = false;
        if (modelName === 'calendar') {
          nameToShow = 'calendar';
          translateModelName = true;
        } else if (modelName === 'autofattura') {
          nameToShow = 'self-invoice';
          translateModelName = true;
        }
        obj = {
          url: modelName,
          item: {
            id: null,
            label: nameToShow,
            translateModelName
          },
          modal_name: null,
          itemInfo: modelVar(modelName, true)
        };
        pageTitle = `${nameToShow} | ${orgName} | Beebeeboard`;
      } else if (model.id && isView === 'view') {
        sendSocketPageView(applicationController.socket, model, false, null, null);
        obj = {
          url: 'view',
          item: model,
          modal_name: params.model_name,
          itemInfo: modelVar(model, false)
        };
        pageTitle = `${model.label} | ${orgName} | Beebeeboard`;
      }
      document.title = pageTitle;
    }

    // openCards is a @tracked plain array on the application controller:
    // reassign a single property on the held object instead of mutating in place
    let cardsChanged = false;
    const nextCards = [...(openCards || [])];
    if (obj && !isPresent) {
      nextCards.push(obj);
      cardsChanged = true;
    }
    if (nextCards.length > 8) {
      nextCards.shift();
      cardsChanged = true;
    }
    if (cardsChanged) {
      applicationController.openCards = nextCards;
    }
    this._resetUI(applicationController);
  }
  _resetUI(applicationController) {
    document.body.classList.remove('hide-header', 'modal-open');
    applicationController.setProperties({
      eventPopup: null,
      showCanvasNotification: false,
      showCanvasAccount: false,
      showCanvasMobileMenu: false,
      itemPreview: false,
      modalComponents: []
    });
  }
  _getApplicationController() {
    const owner = getOwner(this);
    return owner.lookup('controller:application');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { SocketTrackerService as default };
//# sourceMappingURL=socket-tracker.js.map
